import { defineMessages } from "react-intl";
export var messages = defineMessages({
  iconButtonText: {
    id: "jutro-components.widgets.IconButton.button",
    defaultMessage: "Button"
  }
});